import { CALL_API } from '../middleware/api';

// Action Types
export const EMAILTEMPLATES_REQUEST = 'EMAILTEMPLATES_REQUEST';
export const EMAILTEMPLATES_SUCCESS = 'EMAILTEMPLATES_SUCCESS';
export const EMAILTEMPLATES_FAILURE = 'EMAILTEMPLATES_FAILURE';

export const EMAILTEMPLATE_REQUEST = 'EMAILTEMPLATE_REQUEST';
export const EMAILTEMPLATE_SUCCESS = 'EMAILTEMPLATE_SUCCESS';
export const EMAILTEMPLATE_FAILURE = 'EMAILTEMPLATE_FAILURE';

export const EMAILTEMPLATE_ADD_REQUEST = 'EMAILTEMPLATE_ADD_REQUEST';
export const EMAILTEMPLATE_ADD_SUCCESS = 'EMAILTEMPLATE_ADD_SUCCESS';
export const EMAILTEMPLATE_ADD_FAILURE = 'EMAILTEMPLATE_ADD_FAILURE';

export const EMAILTEMPLATE_UPDATE_REQUEST = 'EMAILTEMPLATE_UPDATE_REQUEST';
export const EMAILTEMPLATE_UPDATE_SUCCESS = 'EMAILTEMPLATE_UPDATE_SUCCESS';
export const EMAILTEMPLATE_UPDATE_FAILURE = 'EMAILTEMPLATE_UPDATE_FAILURE';

export const EMAILTEMPLATE_DELETE_REQUEST = 'EMAILTEMPLATE_DELETE_REQUEST';
export const EMAILTEMPLATE_DELETE_SUCCESS = 'EMAILTEMPLATE_DELETE_SUCCESS';
export const EMAILTEMPLATE_DELETE_FAILURE = 'EMAILTEMPLATE_DELETE_FAILURE';

export const EMAILTEMPLATE_RESET = 'EMAILTEMPLATE_RESET';

// Action Creators
export function fetchEmailTemplates() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'emailtemplates',
      authenticated: true,
      types: [EMAILTEMPLATES_REQUEST, EMAILTEMPLATES_SUCCESS, EMAILTEMPLATES_FAILURE]
    }
  };
}

export function fetchEmailTemplateByCustomer(customerId) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `emailtemplates/customer/${customerId}`,
      authenticated: true,
      types: [EMAILTEMPLATE_REQUEST, EMAILTEMPLATE_SUCCESS, EMAILTEMPLATE_FAILURE]
    }
  };
}

export function fetchEmailTemplate(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `emailtemplates/${id}`,
      authenticated: true,
      types: [EMAILTEMPLATE_REQUEST, EMAILTEMPLATE_SUCCESS, EMAILTEMPLATE_FAILURE]
    }
  };
}

export function createEmailTemplate(templateData) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'emailtemplates',
      body: JSON.stringify(templateData),
      authenticated: true,
      types: [EMAILTEMPLATE_ADD_REQUEST, EMAILTEMPLATE_ADD_SUCCESS, EMAILTEMPLATE_ADD_FAILURE]
    }
  };
}

export function updateEmailTemplate(id, templateData) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `emailtemplates/${id}`,
      body: JSON.stringify(templateData),
      authenticated: true,
      types: [EMAILTEMPLATE_UPDATE_REQUEST, EMAILTEMPLATE_UPDATE_SUCCESS, EMAILTEMPLATE_UPDATE_FAILURE]
    }
  };
}

export function deleteEmailTemplate(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `emailtemplates/${id}`,
      authenticated: true,
      types: [EMAILTEMPLATE_DELETE_REQUEST, EMAILTEMPLATE_DELETE_SUCCESS, EMAILTEMPLATE_DELETE_FAILURE]
    }
  };
}

export function resetEmailTemplate() {
  return {
    type: EMAILTEMPLATE_RESET
  };
}

